// src/app/slices/evapPackSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { EvapPackState, IEvapPack, IEvapPackParams } from '../models';

const initialState: EvapPackState = {
  evapPacks: {},
  evap_pack_params: null,
};

const evapPackSlice = createSlice({
  name: 'evap_pack',
  initialState,
  reducers: {
    setEvapPack: (state, action: PayloadAction<IEvapPack>) => {
      state.evapPacks[action.payload.id] = action.payload;
    },
    setEvapPackParams: (state, action: PayloadAction<IEvapPackParams>) => {
      state.evap_pack_params = action.payload;
    },
  },
});

export const { setEvapPack, setEvapPackParams } = evapPackSlice.actions;

export default evapPackSlice.reducer;
